// extracted by mini-css-extract-plugin
module.exports = {"button":"save-button_button__dNFZ_","loading":"save-button_loading__WvgUw"};